// src/utils/helpers.ts

export const formatDate = (d: string) => 
  new Date(d).toLocaleDateString("fr-FR", { 
    day: "2-digit", 
    month: "short" 
  });

export const formatNumber = (num: number): string => 
  new Intl.NumberFormat('fr-FR').format(num);

export const getConnectionStatusStyle = (status: string): { 
  background: string; 
  color: string; 
  label: string 
} => {
  switch(status) {
    case 'online':
      return { 
        background: '#D1FAE5', 
        color: '#059669', 
        label: 'En ligne' 
      };
    case 'idle':
      return { 
        background: '#FEF3C7', 
        color: '#D97706', 
        label: 'Inactif' 
      };
    case 'offline':
    default:
      return { 
        background: '#FEE2E2', 
        color: '#B91C1C', 
        label: 'Hors ligne' 
      };
  }
};